import { Skeleton } from '@mui/material';

type PrimaryNavLinksSkeletonProps = {
  count: number;
};

const PrimaryNavLinksSkeleton = ({ count }: PrimaryNavLinksSkeletonProps) => (
  <>
    {Array.from({ length: count }, (_, index) => (
      <Skeleton
        key={index}
        variant="rounded"
        width={24}
        height={24}
        sx={{ bgcolor: 'neutral600', borderRadius: '6px', my: 0.75, ml: 1.5 }}
      />
    ))}
  </>
);

export default PrimaryNavLinksSkeleton;
